/* eslint-disable max-len */
/* eslint-disable camelcase */
import { serverFetch } from 'utils/serverFetch';
import getLocalizedUrl from 'utils/getLocalizedUrl';
import { API } from 'config/axios';
import { placeSlugTypes } from 'views/motorcycle_rental/utils/constants';
import { geoPath } from 'views/motorcycle_rental/utils/helpers';
import { SLUGS_TYPES } from 'utils/constants';
import generateSlugsHrefLangs from 'utils/generateSlugsHrefLangs';

const handleGeoSSR = async (ctx, slugSSR) => {
  const { res, req, query } = ctx;
  const { slugs } = slugSSR;
  let serverData;
  let hreflangData = null;
  try {
    const pageRes = await serverFetch(ctx, API.geo.rentals, {
      pickup_place_slug:
        slugs.find(({ slug_type }) => placeSlugTypes.includes(slug_type))?.slug || null,
      lat: query.lat,
      lng: query.lng,
      dropoff_location_id: query.dropoff_location_id,
      vehicle_make_slug:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_make)?.slug || null,
      vehicle_model_slug:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_model)?.slug || null,
      vehicle_type_slug:
        slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_type)?.slug || null,
      pickup_date: query.pickup_date,
      dropoff_date: query.dropoff_date,
      page: query.page,
    });
    if (pageRes.success) {
      serverData = pageRes.data;
      hreflangData = await generateSlugsHrefLangs(ctx.asPath, {
        make: serverData.selected_filters.vehicle_make
        || serverData.selected_filters.vehicle_type,
        model: serverData.selected_filters.vehicle_model,
        geo: serverData.selected_filters.pickup_place,
      }, '', serverData?.pagination?.current_page);
    } else {
      switch (pageRes.error.response.status) {
        case 302:
          if (pageRes.error.response.data.error_code === 'ERR002') {
            const destUrl = getLocalizedUrl(
              geoPath([
                pageRes.error.response?.data?.new_vehicle_type_slug || slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_type)?.slug,
                pageRes.error.response.data?.new_vehicle_make_slug || slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_make)?.slug,
                pageRes.error.response?.data?.new_vehicle_model_slug || slugs.find(({ slug_type }) => slug_type === SLUGS_TYPES.vehicle_model)?.slug,
                pageRes.error.response?.data?.new_place_slug || slugs.find(({ slug_type }) => placeSlugTypes.includes(slug_type))?.slug,
              ]),
              req.locale,
            );
            res.writeHead(301, { Location: destUrl });
            res.end();
            return {};
          }
          break;
        default:
          throw pageRes.error;
      }
    }
  } catch (error) {
    res.statusCode = 503;
  }
  return {
    serverData,
    hreflangData,
  };
};

export default handleGeoSSR;
